<template>
    <div class="memorandum_create_block ">
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-sm-12 col-md-12 col-xs-12">
                <left_side_org
                    @org_loaded="get_params"
                    @head_action="head_action"
                    @org_change_state="set_org_state"
                    @show_base_settings="show_base_settings"
                    @create_location="add_location"
                    :percent_add="percent_provider"
                    :has_head_action="has_head_action"
                    :provider_type=provider_type
                    :head_action_icon="head_action_icon"
                    :show_head_action_title="has_head_title"
                >
                </left_side_org>

            </div>

            <div class="col-xl-8 col-lg-8 col-sm-12 col-md-12 col-xs-12">
                <div id="panel-50" class="panel">
                    <b-overlay :show="is_load" rounded="sm">
                        <div class="panel-hdr ">
                            <h2 >
                                <b-form-checkbox class="in_head" switch size="lg"  @change="check_location_all"   v-model=all_loc_checked></b-form-checkbox>
                                {{__t(this.provider_type.toUpperCase() + '_REST_LIST')}}
                            </h2>

                            <div class="panel-toolbar ml-2">

                                <button
                                    v-if="has_online && checked_locations.length > 0"
                                    v-on:click="make_online_batch"
                                    class="mr-4 btn btn-icon btn-sm color-white shadow-0 btn-success  waves-effect waves-themed">
                                    <i class="fal fa-play" ></i>
                                </button>

                                <button
                                   v-if="has_offline && checked_locations.length > 0"
                                   v-on:click="make_offline_batch"
                                    class="mr-4 btn btn-icon btn-sm color-white shadow-0 btn-info  waves-effect waves-themed">
                                    <i class="fal fa-stopwatch" ></i>
                                </button>

                                <button
                                    v-if="has_sync && checked_locations.length > 0"
                                    v-on:click="make_sync_batch"
                                    class="mr-2 btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed"
                                 >
                                    <i class="fal fa-sync"></i>
                                </button>

                                <div class="d-flex position-relative ml-auto" style="max-width: 8rem;">
                                    <i class="fal fa-search position-absolute pos-left fs-lg px-2 py-1 mt-1 fs-xs"></i>
                                    <b-form-input
                                        id="input-live"
                                        class="form-control form-control-sm pl-5"
                                        v-model="search_param"
                                        aria-describedby="input-live-help input-live-feedback"
                                        :placeholder="__t('SEARCH')"
                                        trim
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>
                        <div class="panel-container show">
                            <div class="panel-content loc_g">

                                <slot
                                    name="base_location_list"
                                    :draw_locations="draw_locations"
                                    :listeners="locationListeners"
                                    :has_online="has_online"
                                    :has_offline="has_offline"
                                    :has_sync="has_sync"
                                    :has_sync_update="has_sync_update"
                                    :has_json="has_json"
                                    :has_preview="has_preview"
                                    :has_busy_mode="has_busy_mode"
                                >
                                    <ul class="nav-menu   mb-sm-4 mb-md-0 rounded " v-if="draw_locations.length > 0">
                                        <li class="location_block" v-for="org in draw_locations" >
                                            <location-item
                                                :key="'location_' + org.id"
                                                :item="org"
                                                :has-online="has_online"
                                                :has-offline="has_offline"
                                                :has-sync="has_sync"
                                                :has-sync-update="has_sync_update"
                                                :has-json="has_json"
                                                :has-preview="has_preview"
                                                :has-busy-mode="has_busy_mode"
                                                v-on="locationListeners"
                                          >
                                            </location-item>
                                        </li>
                                    </ul>
                                </slot>
                            </div>
                        </div>
                    </b-overlay>
                </div>
            </div>

            <base_aggregator_settings></base_aggregator_settings>
        </div>
    </div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
});

import {mapGetters} from "vuex";
import Base_aggregator_settings from "./settings/base_aggregator_settings";
import Left_side_org from "../../catalog/organizations/list/left_side";
import Base_location_status from "./location_status/base_location_status.vue";
import LocationItem from "./list/list_item.vue";


export default {
    name: "base_aggregator",
    components: {LocationItem, Base_location_status, Left_side_org, Base_aggregator_settings},
    props : {
        provider_id : {
            type : Number,
            required : true,
        },

        provider_type : {
            type : String,
            required : true,
        },
    },

    data() {
        return {
            active_org : null,
            locations: [],
            is_load: true,
            search_param: "",
        }
    },

    mounted () {
        EventBus.$on('show_load',this.showLoading);
        EventBus.$on('hide_load',this.hideLoading);
    },

    methods: {

        get_state_class(location) {
          /*  if(location.hasOwnProperty('laststate')) {
                let state = location.laststate;
                if (state == 'active' || state == 'online') {
                    return "status status-success";
                }

                if (state == 'inactive' || state == 'offline') {
                    return 'status status-danger';
                }

                return 'status status-warning';
            }*/

            return "";
        },

        showLoading() {
            this.is_load = true;
        },

        hideLoading() {
            this.is_load = false;
        },

        async get_params() {
            this.locations = [];
            this.is_load = true;

            this.load_locations().then(({data}) => {
                this.$store.dispatch('deliveries/LOAD_DELIVERIES');
                if (data.status === "operation_success") {
                    let locations = data.data;
                    locations.map(item => {
                        item.is_loading = false;
                        item.is_checked = false;
                        this.locations.push(item);
                    })
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        show_base_settings() {
            EventBus.$emit('show_aggregator_base_settings');
        },

        edit_location(location){
            this.$emit('edit_location',location);
        },

        async remove_location(location) {
            const is_ok = confirm_me(this.__t('REMOVE?'));
            is_ok.then(res => {
                location.is_loading = true;
                agr_api.delete('/aggregators/locations/' + location.id).then(({data}) => {
                    if (data.status === "operation_success") {
                        EventBus.$emit('reload_locations');
                    }
                }).catch(({response}) => {
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    })
                });

                this.$emit('remove_location', location);
            });

        },

        show_menu(location) {
            this.$emit('show_menu',location);
        },

        make_sync(location,need_confirm = true) {
            this.push_sync(location);

           /* if(need_confirm) {
                const is_ok = confirm_me(this.__t('SYNC?'));
                is_ok.then(res => {

                });
            }
            else {
                this.push_sync(location);
            }*/
        },

        push_sync(location) {
            location.is_loading = true;
            agr_api.put('/aggregators/locations/' + location.id + '/menu').then(({data}) => {
                if (data.status === "operation_success") {
                    location.is_loading = false;
                    let resp = data.data;
                    EventBus.$emit('show_toast', {
                        err: "OK : JOB_ID" + resp.job_id,
                        type: "success",
                        title: "In Progress"
                    })
                }
            }).catch(({response}) => {
                location.is_loading = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
            this.$emit('make_sync', location);
        },

        make_sync_batch() {
            let self = this;
            this.checked_locations.map(function(location){
               self.make_sync(location,false);
            });
        },


        make_online_batch() {
            let self = this;
            this.checked_locations.map(function(location){
                self.make_online_rest(location);
            });
        },

        make_offline_batch() {
            let self = this;
            this.checked_locations.map(function(location){
                self.make_offline_rest(location);
            });
        },

        make_sync_update(location) {
            location.is_loading = true;
            agr_api.patch('/aggregators/locations/' + location.id + '/update_menu').then(({data}) => {
                if (data.status === "operation_success") {
                    location.is_loading = false;
                    let resp = data.data;
                    EventBus.$emit('show_toast', {
                        err: "OK",
                        type: "success",
                        title: "In Progress"
                    })
                }
            }).catch(({response}) => {
                location.is_loading = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });

            this.$emit('make_sync_update',location);
        },

        make_online_rest(location) {
            this.change_location_status(location,'online')
            this.$emit('make_online_rest',location);
        },

        make_offline_rest(location) {
            this.change_location_status(location,'offline')
            this.$emit('make_offline_rest',location);
        },

        make_busy_mode(location,type) {
            let send_type = 'busy';
            if(type == 'off') {
                send_type = 'off_busy';
            }

            this.change_location_status(location,'busy')
            this.$emit('make_busy_rest',location);
        },

        change_location_status(location,status)
        {
            location.is_loading = true;
            agr_api.patch('/aggregators/locations/' + location.id + '/status/' + status).then(({data}) => {
                if (data.status === "operation_success") {
                    location.is_loading = false;
                }
            }).catch(({response}) => {
                location.is_loading = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        check_location_all() {
            let state = !this.is_all_location_selected;
            console.log('push_state',state);
            this.draw_locations.map(item => {
                item.is_checked = state;
            });
        },


        get_json(location) {
            this.$emit('get_json',location);
        },


        async load_provider() {
            return agr_api.post('/aggregators/' + this.provider_id);
        },


        async load_locations() {
            return agr_api.post('/aggregators/' + this.provider_id + "/locations");
        },


        async set_org_state(org) {
            if(org.hasOwnProperty('is_active') && org.is_active) {
                this.active_org = org;
            }
            else {
                this.active_org = null;
            }
        },

        head_action () {
            this.$emit('head_action');
        },

        add_location(cur_organization) {
            this.$emit('add_location',cur_organization);
        },

        setActiveLocation(location) {
            location.is_checked = !location.is_checked;
        },

        has_delivery_location(location) {
            if(location.hasOwnProperty("delivery_auto")) {
                if(location.delivery_auto != null && parseInt(location.delivery_auto.id) > 0) {
                    return true;
                }
            }
            return false;
        },

        attached_delivery_uniq(location) {
            if(this.has_delivery_location(location)) {
                return location.delivery_auto.delivery_location_id;
            }

            return '';
        }

    },

    computed: {
        ...mapFields([
            'user'
        ]),

        ...mapGetters({
            'aggregator'        : "aggregator/getAggregator",
            'is_load_complete'  : "aggregator/is_load_complete"
        }),


        locationListeners() {
            return {
                edit:        item => this.edit_location(item),
                toggle:      item => this.setActiveLocation(item),
                remove:      item => this.remove_location(item),
                online:      item => this.make_online_rest(item),
                offline:     item => this.make_offline_rest(item),
                sync:        item => this.make_sync(item),
                'sync-update': item => this.make_sync_update(item),
                json:        item => this.get_json(item),
                preview:     item => this.show_menu(item),
                'busy-on':   item => this.make_busy_mode(item, 'on'),
                'busy-off':  item => this.make_busy_mode(item, 'off'),
            }
        },

        has_head_action() {
            return this.aggregator.aggregators_params.has_head;
        },

        has_head_title() {
            console.log(this.provider_type);
            if(this.provider_type == 'uklon-market') {
                return false;
            }

            return true;
        },

        head_action_icon() {
            if(this.provider_type == 'uklon-market') {
                return 'fal fa-play';
            }

            return 'fal fa-user-lock';
        },

        has_sync_update() {
            return this.aggregator.aggregators_params.has_sync_update;
        },

        has_sync() {
            return this.aggregator.aggregators_params.has_sync;
        },

        has_preview() {
            return this.aggregator.aggregators_params.has_preview;
        },

        has_json() {
            return this.aggregator.aggregators_params.has_json;
        },

        has_offline() {
            return this.aggregator.aggregators_params.has_offline;
        },

        has_online() {
            return this.aggregator.aggregators_params.has_online;
        },

        has_busy_mode() {
            if(this.aggregator.aggregators_params.hasOwnProperty("busy_mode")) {
                return this.aggregator.aggregators_params.busy_mode;
            }

            return false;
        },

        all_loc_checked: {
              get () {
                return this.is_all_location_selected;
              },
              set (val) {

              }
        },


        is_all_location_selected() {
            let items = this.draw_locations.filter(item => {
                return !item.is_checked;
            });
            return items.length <= 0;
        },


        checked_locations() {
            return  this.draw_locations.filter(item => {
                return item.is_checked;
            });
        },

        percent_provider() {
            try {
                return parseFloat(this.aggregator.basic_params.percent);
            }
            catch (e) {

            }
            return 0;
        },



        draw_locations()
        {
            let items = this.locations;

            if(this.active_org != null) {
                items = items.filter(item => {
                    return parseInt(item.parent_id) === parseInt(this.active_org.id);
                });
            }

            if(this.search_param.length > 1) {
                items = items.filter(item => {
                    let inside_title = String(item.title.toLowerCase()).match(new RegExp(this.search_param, "gi"));
                    let inside_uniq  = String(item.uniq_id.toLowerCase()).match(new RegExp(this.search_param, "gi"));

                    return inside_title || inside_uniq;
                })
            }
            return items;
        }

    }
}
</script>

<style scoped>

</style>
